import React, { useState } from "react";
import { useSelector } from "react-redux";
import {
  Pane,
  Paragraph,
  TabNavigation,
  Tab,
  Card,
  Text
} from "evergreen-ui";
import Breadcrumbs from "../../components/layout/Breadcrumbs.js";
import UserSettings from "./UserSettings.js";
import Billing from "./Billing.js";
import DeleteUser from "./DeleteUser.js";
import DeletePublisher from "./DeletePublisher.js";
import CollaboratorsPane from "./CollaboratorsPane.js";
import AccountSettings from "./AccountSettings.js";
import RoyaltyAndCurrencySettings from "./RoyaltyAndCurrencySettings.js";

function Settings() {
  const [selectedTab, setSelectedTab] = useState("team");
  const currentpublisher = useSelector((state) => state.currentpublisher.value);
  const currentUser = useSelector((state) => state.user.value);
  const pubusers = useSelector((state) => state.pubusers?.value || []);

  // Get the current user's role to determine permissions
  const currentUserData = pubusers.find(user => parseInt(user.user.id) === parseInt(currentUser));
  const userRole = currentUserData?.role?.name || "";

  // Check if user has admin privileges (owner or admin)
  const hasAdminPrivileges = userRole === "owner" || userRole === "admin";

  const renderContent = () => {
    switch(selectedTab) {
      case "team":
        return <CollaboratorsPane />;
      case "orderStatus":
      case "shippingType":
      case "salesperson":
        return (
          <UserSettings
            category="orderOptions"
            activeSection={selectedTab}
          />
        );
      case "customerClass":
      case "paymentTerm":
        return (
          <UserSettings
            category="customerOptions"
            activeSection={selectedTab}
          />
        );
      case "paymentType":
      case "expenseCategory":
      case "royaltyAccounting":
      case "currency":
        return (
          selectedTab === "royaltyAccounting" || selectedTab === "currency" ? (
            <RoyaltyAndCurrencySettings activeSection={selectedTab} />
          ) : (
            <UserSettings
              category="royaltyExpenseOptions"
              activeSection={selectedTab}
            />
          )
        );
      case "account":
        return <AccountSettings />;
      case "billing":
        return (
          <Card
            border="default"
            padding={32}
            backgroundColor="white"
            elevation={1}
          >
            <Paragraph size={500} marginBottom={32}>Subscription & Billing</Paragraph>
            <Billing />
            <Pane marginTop={32} borderTop paddingTop={16}>
              <Text color="red500" size={300} cursor="pointer">
                Delete Publisher Account
              </Text>
            </Pane>
          </Card>
        );
      default:
        return null;
    }
  };

  return (
    <Pane>
      <Pane
        borderBottom="solid"
        borderBottomColor="#e6e4e0"
        borderBottomWidth="1px"
        paddingX={16}
        paddingTop={16}
      >
        <Breadcrumbs singlePage="HOME" sourceUrl="/dashboard" />
        <Pane
          marginTop={16}
          marginBottom={8}
          size={300}
          display="flex"
          justifyContent="space-between"
        >
          <Paragraph marginLeft={4} size={300} fontSize={18}>
            Settings
          </Paragraph>
        </Pane>
      </Pane>

      <Pane display="flex" padding={16}>
        {/* Left Navigation */}
        <Pane width={240} borderRight paddingRight={16}>
          <TabNavigation>
            <Paragraph size={500} marginTop={16} marginBottom={8} color="muted">
              Account
            </Paragraph>
            <Tab
              id="team"
              isSelected={selectedTab === "team"}
              onSelect={() => setSelectedTab("team")}
            >
              Your Team
            </Tab><br />
            <Tab
              id="account"
              isSelected={selectedTab === "account"}
              onSelect={() => setSelectedTab("account")}
            >
              Profile
            </Tab><br/>
            {/* Only show Subscription tab for users with admin privileges */}
            {hasAdminPrivileges && (
              <>
                <Tab
                  id="billing"
                  isSelected={selectedTab === "billing"}
                  onSelect={() => setSelectedTab("billing")}
                >
                  Subscription
                </Tab>
              </>
            )}

            <Paragraph size={500} marginTop={16} marginBottom={8} color="muted">
              Customization & Setup
            </Paragraph>
            <Paragraph size={400} marginTop={-16} marginBottom={8} color="muted">
              <small>
                <br />
                (These settings are used to customize the platform for your business.)
              </small>
            </Paragraph>

            <Tab
              id="currency"
              isSelected={selectedTab === "currency"}
              onSelect={() => setSelectedTab("currency")}
            >
              Currency
            </Tab>
            <br />
            <Tab
              id="customerClass"
              isSelected={selectedTab === "customerClass"}
              onSelect={() => setSelectedTab("customerClass")}
            >
              Customer Class
            </Tab>
            <Tab
              id="expenseCategory"
              isSelected={selectedTab === "expenseCategory"}
              onSelect={() => setSelectedTab("expenseCategory")}
            >
              Expense Categories
            </Tab>

            <Tab
              id="orderStatus"
              isSelected={selectedTab === "orderStatus"}
              onSelect={() => setSelectedTab("orderStatus")}
            >
              Order Statuses
            </Tab>

            <Tab
              id="paymentType"
              isSelected={selectedTab === "paymentType"}
              onSelect={() => setSelectedTab("paymentType")}
            >
              Royalty Payment Methods
            </Tab>

            <Tab
              id="royaltyAccounting"
              isSelected={selectedTab === "royaltyAccounting"}
              onSelect={() => setSelectedTab("royaltyAccounting")}
            >
              Royalty Accounting
            </Tab>
            <br />

            <Tab
              id="paymentTerm"
              isSelected={selectedTab === "paymentTerm"}
              onSelect={() => setSelectedTab("paymentTerm")}
            >
              Payment Terms
            </Tab>
            <br />

            <Tab
              id="shippingType"
              isSelected={selectedTab === "shippingType"}
              onSelect={() => setSelectedTab("shippingType")}
            >
              Shipping Types
            </Tab>
            <Tab
              id="salesperson"
              isSelected={selectedTab === "salesperson"}
              onSelect={() => setSelectedTab("salesperson")}
            >
              Sales People
            </Tab>

          </TabNavigation>
        </Pane>

        {/* Right Content Area */}
        <Pane flex={1} paddingLeft={32}>
          {renderContent()}
        </Pane>
      </Pane>
    </Pane>
  );
}

export default Settings;
